/* ==========================================================================
   VyomTara | Watch and Buy
   Standalone script. It only controls elements inside <vt-watch-and-buy>
   and its own popup. It does not change any existing theme script.
   ========================================================================== */
(function () {
  'use strict';

  if (window.customElements.get('vt-watch-and-buy')) return;

  var ICONS = {
    prev: '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M15 5l-7 7 7 7"/></svg>',
    next: '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M9 5l7 7-7 7"/></svg>',
    close: '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18"/></svg>',
    sound: '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M11 5L6 9H3v6h3l5 4V5z" fill="currentColor" stroke="none"/><path d="M15.5 8.5a5 5 0 010 7M18.5 5.5a9 9 0 010 13"/></svg>',
    muted: '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M11 5L6 9H3v6h3l5 4V5z" fill="currentColor" stroke="none"/><path d="M16 9l5 6M21 9l-5 6"/></svg>',
    share: '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><circle cx="18" cy="5" r="2.5"/><circle cx="6" cy="12" r="2.5"/><circle cx="18" cy="19" r="2.5"/><path d="M8.2 10.8l7.6-4.4M8.2 13.2l7.6 4.4"/></svg>',
    link: '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M14 4h6v6M20 4l-9 9M18 14v5a1 1 0 01-1 1H5a1 1 0 01-1-1V7a1 1 0 011-1h5"/></svg>',
    play: '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false"><path d="M8 5.5v13l11-6.5z"/></svg>'
  };

  function bool(value) {
    return value === 'true';
  }

  class VTWatchAndBuy extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;

      var d = this.dataset;
      this.opts = {
        autoSlide: bool(d.autoslide),
        autoSlideSpeed: Math.max(2, parseFloat(d.autoslideSpeed) || 4) * 1000,
        playback: d.playback || 'autoplay',
        centerHighlight: bool(d.centerHighlight),
        soundOnOpen: bool(d.soundOnOpen),
        showNeighbours: bool(d.showNeighbours),
        showMute: bool(d.showMute),
        showShare: bool(d.showShare),
        showProduct: bool(d.showProduct),
        showVariants: bool(d.showVariants),
        showCompare: bool(d.showCompare),
        afterAdd: d.afterAdd || 'stay',
        cartAddUrl: d.cartAddUrl || '/cart/add',
        cartUrl: d.cartUrl || '/cart',
        label: d.label || 'Watch and Buy',
        text: {
          add: d.textAdd || 'Add to cart',
          adding: d.textAdding || 'Adding...',
          added: d.textAdded || 'Added to cart',
          soldout: d.textSoldout || 'Sold out',
          unavailable: d.textUnavailable || 'Unavailable',
          error: d.textError || "Couldn't add to cart. Please try again.",
          copied: d.textCopied || 'Link copied',
          share: d.textShare || 'Share'
        }
      };

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.isTouch = window.matchMedia('(hover: none)').matches;

      this.track = this.querySelector('[data-vt-track]');
      this.carousel = this.querySelector('[data-vt-carousel]');
      this.cards = Array.prototype.slice.call(this.querySelectorAll('[data-vt-card]'));
      this.items = [];
      this.pauseUntil = 0;
      this.hovering = false;
      this.isOpen = false;
      this.index = 0;

      this.collectItems();
      if (!this.track) return;

      this.bindCarousel();
      this.setupCardVideos();
      this.startAuto();

      this.onBlockSelect = this.handleBlockSelect.bind(this);
      document.addEventListener('shopify:block:select', this.onBlockSelect);
    }

    disconnectedCallback() {
      this.stopAuto();
      if (this.io) this.io.disconnect();
      if (this.onResize) window.removeEventListener('resize', this.onResize);
      if (this.onBlockSelect) document.removeEventListener('shopify:block:select', this.onBlockSelect);
      if (this.popup) {
        if (this.isOpen) this.close(true);
        this.popup.remove();
        this.popup = null;
      }
      this._ready = false;
    }

    /* ---------- Data ---------- */
    collectItems() {
      var self = this;
      this.cards.forEach(function (card) {
        var dataEl = card.querySelector('[data-vt-data]');
        if (!dataEl) return;
        var data;
        try {
          data = JSON.parse(dataEl.textContent);
        } catch (e) {
          return;
        }
        card.dataset.popupIndex = String(self.items.length);
        self.items.push(data);
      });
    }

    /* ---------- Carousel ---------- */
    bindCarousel() {
      var self = this;
      this.prevBtn = this.querySelector('[data-vt-prev]');
      this.nextBtn = this.querySelector('[data-vt-next]');

      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', function () {
          self.pauseAutoFor(8000);
          self.scrollByStep(-1);
        });
      }
      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', function () {
          self.pauseAutoFor(8000);
          self.scrollByStep(1);
        });
      }

      this.track.addEventListener('scroll', function () {
        if (self._raf) return;
        self._raf = window.requestAnimationFrame(function () {
          self._raf = null;
          self.updateCenter();
        });
      }, { passive: true });

      this.track.addEventListener('mouseenter', function () { self.hovering = true; });
      this.track.addEventListener('mouseleave', function () { self.hovering = false; });
      this.track.addEventListener('touchstart', function () { self.pauseAutoFor(6000); }, { passive: true });
      this.track.addEventListener('focusin', function () { self.pauseAutoFor(8000); });

      this.track.addEventListener('click', function (event) {
        var opener = event.target.closest('[data-vt-open]');
        if (!opener) return;
        var card = opener.closest('[data-vt-card]');
        if (!card || card.dataset.popupIndex === undefined) return;
        event.preventDefault();
        self.open(parseInt(card.dataset.popupIndex, 10), opener);
      });

      this.onResize = function () {
        self.updateLayout();
        self.updateCenter();
      };
      window.addEventListener('resize', this.onResize);

      this.updateLayout();
      this.updateCenter();
      window.setTimeout(function () { self.updateLayout(); self.updateCenter(); }, 400);
    }

    getStep() {
      var card = this.cards[0];
      if (!card) return this.track.clientWidth;
      var gap = parseFloat(window.getComputedStyle(this.track).columnGap) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    scrollByStep(direction) {
      var t = this.track;
      var max = t.scrollWidth - t.clientWidth;
      if (max <= 4) return;
      var behavior = this.reducedMotion ? 'auto' : 'smooth';
      if (direction > 0 && t.scrollLeft >= max - 4) {
        t.scrollTo({ left: 0, behavior: behavior });
      } else if (direction < 0 && t.scrollLeft <= 4) {
        t.scrollTo({ left: max, behavior: behavior });
      } else {
        t.scrollBy({ left: direction * this.getStep(), behavior: behavior });
      }
    }

    updateLayout() {
      if (!this.carousel) return;
      var scrollable = this.track.scrollWidth - this.track.clientWidth > 4;
      this.carousel.classList.toggle('is-static', !scrollable);

      var firstCard = this.cards[0];
      var media = firstCard && firstCard.querySelector('.vt-wab__media');
      if (media) {
        var top = firstCard.getBoundingClientRect().top - this.carousel.getBoundingClientRect().top;
        this.carousel.style.setProperty('--vt-wab-arrow-top', Math.round(top + media.offsetHeight / 2) + 'px');
      }
    }

    updateCenter() {
      if (!this.opts.centerHighlight || !this.isTouch || !this.cards.length) return;
      var rect = this.track.getBoundingClientRect();
      var center = rect.left + rect.width / 2;
      var best = null;
      var bestDistance = Infinity;

      this.cards.forEach(function (card) {
        var r = card.getBoundingClientRect();
        var distance = Math.abs(r.left + r.width / 2 - center);
        if (distance < bestDistance) {
          bestDistance = distance;
          best = card;
        }
      });

      var self = this;
      this.cards.forEach(function (card) {
        var active = card === best;
        card.classList.toggle('is-centered', active);
        if (self.opts.playback === 'hover') {
          var video = card.querySelector('.vt-wab__video');
          if (!video) return;
          if (active) self.playCardVideo(video);
          else video.pause();
        }
      });
    }

    startAuto() {
      if (!this.opts.autoSlide || this.reducedMotion || this.cards.length < 2) return;
      this.stopAuto();
      var self = this;
      this.timer = window.setInterval(function () {
        if (self.isOpen || self.hovering || document.hidden || Date.now() < self.pauseUntil) return;
        self.scrollByStep(1);
      }, this.opts.autoSlideSpeed);
    }

    stopAuto() {
      if (this.timer) window.clearInterval(this.timer);
      this.timer = null;
    }

    pauseAutoFor(ms) {
      this.pauseUntil = Date.now() + ms;
    }

    handleBlockSelect(event) {
      if (!event.detail || !event.detail.blockId) return;
      var card = this.querySelector('[data-block-id="' + event.detail.blockId + '"]');
      if (!card) return;
      this.pauseAutoFor(60000);
      this.track.scrollTo({ left: Math.max(0, card.offsetLeft - 6), behavior: 'smooth' });
    }

    /* ---------- Card videos ---------- */
    setupCardVideos() {
      var self = this;
      this.cardVideos = Array.prototype.slice.call(this.querySelectorAll('.vt-wab__video'));

      this.playCardVideo = function (video) {
        if (self.isOpen || self.opts.playback === 'none') return;
        if (!video.getAttribute('src') && video.dataset.src) {
          video.src = video.dataset.src;
        }
        video.muted = true;
        video.defaultMuted = true;
        var promise = video.play();
        if (promise && typeof promise.catch === 'function') promise.catch(function () {});
      };

      if (!this.cardVideos.length || this.opts.playback === 'none') return;

      if (this.opts.playback === 'autoplay') {
        if ('IntersectionObserver' in window) {
          this.io = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              var video = entry.target;
              video.dataset.visible = entry.isIntersecting ? 'true' : 'false';
              if (entry.isIntersecting) self.playCardVideo(video);
              else video.pause();
            });
          }, { threshold: 0.35 });
          this.cardVideos.forEach(function (video) { self.io.observe(video); });
        } else {
          this.cardVideos.forEach(function (video) { self.playCardVideo(video); });
        }
      }

      if (this.opts.playback === 'hover' && !this.isTouch) {
        this.cards.forEach(function (card) {
          var video = card.querySelector('.vt-wab__video');
          if (!video) return;
          card.addEventListener('mouseenter', function () { self.playCardVideo(video); });
          card.addEventListener('mouseleave', function () { video.pause(); });
        });
      }
    }

    pauseCardVideos() {
      (this.cardVideos || []).forEach(function (video) { video.pause(); });
    }

    resumeCardVideos() {
      if (this.opts.playback !== 'autoplay') return;
      var self = this;
      (this.cardVideos || []).forEach(function (video) {
        if (!self.io || video.dataset.visible === 'true') self.playCardVideo(video);
      });
    }

    /* ---------- Popup ---------- */
    buildPopup() {
      if (this.popup) return;
      var self = this;
      var wrapper = this.closest('.vt-wab');
      var popup = document.createElement('div');
      popup.className = 'vt-wab-popup';
      popup.hidden = true;
      popup.setAttribute('role', 'dialog');
      popup.setAttribute('aria-modal', 'true');
      popup.setAttribute('aria-label', this.opts.label);
      if (wrapper && wrapper.getAttribute('style')) popup.setAttribute('style', wrapper.getAttribute('style'));

      popup.innerHTML =
        '<div class="vt-wab-popup__backdrop" data-close></div>' +
        '<div class="vt-wab-popup__stage" data-stage></div>' +
        '<button type="button" class="vt-wab-popup__nav vt-wab-popup__nav--prev" data-prev aria-label="Previous video">' + ICONS.prev + '</button>' +
        '<div class="vt-wab-popup__player" data-player>' +
          '<video class="vt-wab-popup__video" data-video playsinline loop preload="auto" disablepictureinpicture></video>' +
          '<img class="vt-wab-popup__poster" data-poster alt="" hidden>' +
          '<span class="vt-wab-popup__spinner" aria-hidden="true"></span>' +
          '<span class="vt-wab-popup__paused" aria-hidden="true">' + ICONS.play + '</span>' +
          '<div class="vt-wab-popup__top">' +
            '<button type="button" class="vt-wab-popup__icon-btn" data-mute aria-label="Unmute video">' + ICONS.muted + '</button>' +
            '<button type="button" class="vt-wab-popup__icon-btn" data-close aria-label="Close">' + ICONS.close + '</button>' +
          '</div>' +
          '<p class="vt-wab-popup__toast" data-toast role="status" aria-live="polite"></p>' +
          '<div class="vt-wab-popup__bottom">' +
            '<div class="vt-wab-popup__side" data-side>' +
              '<button type="button" class="vt-wab-popup__icon-btn" data-share aria-label="Share">' + ICONS.share + '</button>' +
              '<span class="vt-wab-popup__side-label" data-share-label></span>' +
            '</div>' +
            '<div class="vt-wab-pc" data-pc>' +
              '<div class="vt-wab-pc__row">' +
                '<img class="vt-wab-pc__img" data-pc-img alt="" width="48" height="60">' +
                '<div class="vt-wab-pc__meta">' +
                  '<p class="vt-wab-pc__title" data-pc-title></p>' +
                  '<p class="vt-wab-pc__price"><span data-pc-price></span><s class="vt-wab-pc__was" data-pc-was hidden></s></p>' +
                '</div>' +
                '<a class="vt-wab-pc__link" data-pc-link href="#" aria-label="View product">' + ICONS.link + '</a>' +
              '</div>' +
              '<div class="vt-wab-pc__options" data-pc-options hidden></div>' +
              '<button type="button" class="vt-wab-pc__atc" data-pc-atc></button>' +
              '<p class="vt-wab-pc__msg" data-pc-msg role="status" aria-live="polite"></p>' +
            '</div>' +
          '</div>' +
        '</div>' +
        '<button type="button" class="vt-wab-popup__nav vt-wab-popup__nav--next" data-next aria-label="Next video">' + ICONS.next + '</button>';

      document.body.appendChild(popup);
      this.popup = popup;

      this.stage = popup.querySelector('[data-stage]');
      this.player = popup.querySelector('[data-player]');
      this.video = popup.querySelector('[data-video]');
      this.posterImg = popup.querySelector('[data-poster]');
      this.muteBtn = popup.querySelector('[data-mute]');
      this.toastEl = popup.querySelector('[data-toast]');
      this.pc = popup.querySelector('[data-pc]');
      this.pcImg = popup.querySelector('[data-pc-img]');
      this.pcTitle = popup.querySelector('[data-pc-title]');
      this.pcPrice = popup.querySelector('[data-pc-price]');
      this.pcWas = popup.querySelector('[data-pc-was]');
      this.pcLink = popup.querySelector('[data-pc-link]');
      this.pcOptions = popup.querySelector('[data-pc-options]');
      this.pcAtc = popup.querySelector('[data-pc-atc]');
      this.pcMsg = popup.querySelector('[data-pc-msg]');

      popup.querySelector('[data-share-label]').textContent = this.opts.text.share;

      if (!this.opts.showMute) this.muteBtn.remove();
      if (!this.opts.showShare) popup.querySelector('[data-side]').remove();
      if (!this.opts.showProduct) {
        this.pc.remove();
        this.pc = null;
      }

      /* Neighbour thumbnails */
      this.ghosts = [];
      if (this.opts.showNeighbours) {
        this.items.forEach(function (item, i) {
          var ghost = document.createElement('button');
          ghost.type = 'button';
          ghost.className = 'vt-wab-popup__ghost';
          ghost.dataset.ghost = String(i);
          ghost.tabIndex = -1;
          ghost.setAttribute('aria-label', 'Play video: ' + (item.title || 'Video ' + (i + 1)));
          if (item.poster) {
            var img = document.createElement('img');
            img.src = item.poster;
            img.alt = '';
            img.loading = 'lazy';
            ghost.appendChild(img);
          }
          self.stage.appendChild(ghost);
          self.ghosts.push(ghost);
        });
      }

      /* Clicks */
      popup.addEventListener('click', function (event) {
        var target = event.target;
        if (target.closest('[data-close]')) { self.close(); return; }
        if (target.closest('[data-prev]')) { self.go(self.index - 1); return; }
        if (target.closest('[data-next]')) { self.go(self.index + 1); return; }
        if (target.closest('[data-mute]')) { self.toggleMute(); return; }
        if (target.closest('[data-share]')) { self.share(); return; }
        var ghost = target.closest('[data-ghost]');
        if (ghost) { self.go(parseInt(ghost.dataset.ghost, 10)); return; }
        var optionBtn = target.closest('[data-opt-index]');
        if (optionBtn) { self.selectOption(optionBtn); return; }
        if (target.closest('[data-pc-atc]')) { self.addToCart(); return; }
        if (target === self.video) { self.togglePlay(); }
      });

      /* Swipe on the player */
      this.player.addEventListener('touchstart', function (event) {
        if (event.target.closest('.vt-wab-pc')) return;
        self._touchX = event.touches[0].clientX;
        self._touchY = event.touches[0].clientY;
      }, { passive: true });

      this.player.addEventListener('touchend', function (event) {
        if (self._touchX == null) return;
        var dx = event.changedTouches[0].clientX - self._touchX;
        var dy = event.changedTouches[0].clientY - self._touchY;
        self._touchX = null;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) {
          self.go(self.index + (dx < 0 ? 1 : -1));
        } else if (Math.abs(dy) > 70 && Math.abs(dy) > Math.abs(dx)) {
          self.go(self.index + (dy < 0 ? 1 : -1));
        }
      }, { passive: true });

      /* Video loading state */
      this.video.addEventListener('waiting', function () { self.player.classList.add('is-loading'); });
      this.video.addEventListener('playing', function () { self.player.classList.remove('is-loading', 'is-paused'); });
      this.video.addEventListener('canplay', function () { self.player.classList.remove('is-loading'); });

      this.onKey = function (event) {
        if (!self.isOpen) return;
        if (event.key === 'Escape') {
          event.preventDefault();
          self.close();
        } else if (event.key === 'ArrowRight') {
          self.go(self.index + 1);
        } else if (event.key === 'ArrowLeft') {
          self.go(self.index - 1);
        } else if (event.key === 'Tab') {
          self.trapFocus(event);
        }
      };
    }

    open(index, trigger) {
      if (!this.items.length) return;
      this.buildPopup();
      this.lastFocus = trigger || document.activeElement;
      this.isOpen = true;
      this.muted = !this.opts.soundOnOpen;
      this.pauseCardVideos();

      this.popup.classList.toggle('is-single', this.items.length < 2);
      this.popup.hidden = false;
      document.documentElement.classList.add('vt-wab-lock');
      document.addEventListener('keydown', this.onKey);

      /* Called directly inside the click, so the browser allows sound */
      this.go(index);

      var closeBtn = this.popup.querySelector('.vt-wab-popup__top [data-close]');
      window.requestAnimationFrame(function () {
        if (closeBtn) closeBtn.focus({ preventScroll: true });
      });
    }

    close(silent) {
      if (!this.isOpen) return;
      this.isOpen = false;
      window.clearTimeout(this._addedTimer);
      window.clearTimeout(this._toastTimer);

      if (this.video) {
        this.video.pause();
        this.video.removeAttribute('src');
        this.video.load();
      }
      if (this.popup) this.popup.hidden = true;
      document.documentElement.classList.remove('vt-wab-lock');
      document.removeEventListener('keydown', this.onKey);

      if (silent) return;
      this.pauseAutoFor(3000);
      this.resumeCardVideos();
      if (this.lastFocus && typeof this.lastFocus.focus === 'function') {
        this.lastFocus.focus({ preventScroll: true });
      }
    }

    go(index) {
      var count = this.items.length;
      if (!count) return;
      this.index = ((index % count) + count) % count;
      var item = this.items[this.index];
      this.renderGhosts();
      this.loadVideo(item);
      this.renderProduct(item);
    }

    renderGhosts() {
      if (!this.ghosts || !this.ghosts.length) return;
      var count = this.items.length;
      var current = this.index;

      this.ghosts.forEach(function (ghost, i) {
        var offset = i - current;
        if (count > 2) {
          if (offset > count / 2) offset -= count;
          if (offset < -count / 2) offset += count;
        }
        var distance = Math.abs(offset);

        if (offset === 0 || distance > 2) {
          ghost.style.transform = 'translate(-50%, -50%) scale(0.7)';
          ghost.style.opacity = '0';
          ghost.style.zIndex = '0';
          ghost.style.pointerEvents = 'none';
          ghost.style.filter = '';
        } else if (distance === 1) {
          ghost.style.transform = 'translate(-50%, -50%) translateX(' + offset * 62 + '%) scale(0.84)';
          ghost.style.opacity = '1';
          ghost.style.zIndex = '2';
          ghost.style.pointerEvents = 'auto';
          ghost.style.filter = 'brightness(0.7)';
        } else {
          ghost.style.transform = 'translate(-50%, -50%) translateX(' + offset * 112 + '%) scale(0.66)';
          ghost.style.opacity = '1';
          ghost.style.zIndex = '1';
          ghost.style.pointerEvents = 'auto';
          ghost.style.filter = 'brightness(0.5)';
        }
      });
    }

    loadVideo(item) {
      var self = this;
      var video = this.video;
      video.pause();
      this.player.classList.remove('is-paused');
      this.posterImg.hidden = true;

      if (item.video) {
        video.hidden = false;
        this.player.classList.add('is-loading');
        if (item.poster) video.poster = item.poster;
        else video.removeAttribute('poster');
        video.src = item.video;
        video.muted = this.muted;

        var promise = video.play();
        if (promise && typeof promise.catch === 'function') {
          promise.catch(function (error) {
            if (error && error.name === 'AbortError') return;
            if (!video.muted) {
              /* Browser blocked sound: fall back to muted playback */
              video.muted = true;
              self.muted = true;
              self.updateMuteBtn();
              video.play().catch(function () {
                self.player.classList.remove('is-loading');
                self.player.classList.add('is-paused');
              });
            } else {
              self.player.classList.remove('is-loading');
              self.player.classList.add('is-paused');
            }
          });
        }
      } else {
        video.removeAttribute('src');
        video.load();
        video.hidden = true;
        this.player.classList.remove('is-loading');
        if (item.poster) {
          this.posterImg.src = item.poster;
          this.posterImg.hidden = false;
        }
      }

      if (this.muteBtn) this.muteBtn.hidden = !item.video;
      this.updateMuteBtn();
    }

    togglePlay() {
      var video = this.video;
      if (!video.getAttribute('src')) return;
      if (video.paused) {
        video.play().catch(function () {});
        this.player.classList.remove('is-paused');
      } else {
        video.pause();
        this.player.classList.add('is-paused');
      }
    }

    toggleMute() {
      this.muted = !this.muted;
      this.video.muted = this.muted;
      if (!this.muted && this.video.paused && this.video.getAttribute('src')) {
        this.video.play().catch(function () {});
        this.player.classList.remove('is-paused');
      }
      this.updateMuteBtn();
    }

    updateMuteBtn() {
      if (!this.muteBtn) return;
      this.muteBtn.innerHTML = this.muted ? ICONS.muted : ICONS.sound;
      this.muteBtn.setAttribute('aria-label', this.muted ? 'Unmute video' : 'Mute video');
    }

    share() {
      var self = this;
      var item = this.items[this.index];
      if (!item) return;
      var path = item.product ? item.product.url : window.location.pathname;
      var url = new URL(path, window.location.origin).href;
      var title = item.title || document.title;

      if (navigator.share) {
        navigator.share({ title: title, url: url }).catch(function () {});
        return;
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(function () {
          self.toast(self.opts.text.copied);
        }).catch(function () {
          window.prompt(title, url);
        });
      } else {
        window.prompt(title, url);
      }
    }

    toast(message) {
      var el = this.toastEl;
      if (!el) return;
      el.textContent = message;
      el.classList.add('is-visible');
      window.clearTimeout(this._toastTimer);
      this._toastTimer = window.setTimeout(function () {
        el.classList.remove('is-visible');
      }, 1800);
    }

    trapFocus(event) {
      var focusable = Array.prototype.slice.call(
        this.popup.querySelectorAll('button:not([disabled]), a[href], [tabindex]')
      ).filter(function (el) {
        return el.tabIndex >= 0 && !el.hidden && el.getClientRects().length > 0;
      });
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      } else if (!this.popup.contains(document.activeElement)) {
        event.preventDefault();
        first.focus();
      }
    }

    /* ---------- Product card ---------- */
    renderProduct(item) {
      if (!this.pc) return;
      var product = item.product;
      window.clearTimeout(this._addedTimer);

      if (!product || !product.variants || !product.variants.length) {
        this.pc.hidden = true;
        this.product = null;
        return;
      }

      this.pc.hidden = false;
      this.product = product;

      var first = product.variants.filter(function (v) { return v.id === product.selected; })[0] ||
        product.variants.filter(function (v) { return v.available; })[0] ||
        product.variants[0];
      this.selected = first.options.slice();

      this.pcTitle.textContent = item.title || product.title;
      this.pcLink.href = product.url;
      this.pcLink.setAttribute('aria-label', 'View product: ' + product.title);
      this.pcMsg.textContent = '';
      this.pcMsg.classList.remove('is-error');

      this.renderOptions();
      this.updateVariant();
    }

    renderOptions() {
      var wrap = this.pcOptions;
      var product = this.product;
      wrap.innerHTML = '';

      if (!this.opts.showVariants || product.hasOnlyDefault || !product.options || !product.options.length) {
        wrap.hidden = true;
        return;
      }
      wrap.hidden = false;

      product.options.forEach(function (name, i) {
        var values = [];
        product.variants.forEach(function (variant) {
          var value = variant.options[i];
          if (value != null && values.indexOf(value) === -1) values.push(value);
        });

        var group = document.createElement('div');
        group.className = 'vt-wab-pc__opt';
        group.setAttribute('role', 'radiogroup');
        group.setAttribute('aria-label', name);

        var label = document.createElement('p');
        label.className = 'vt-wab-pc__opt-name';
        label.dataset.optName = name;
        label.textContent = name;

        var list = document.createElement('div');
        list.className = 'vt-wab-pc__values';

        values.forEach(function (value) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'vt-wab-pc__value';
          btn.textContent = value;
          btn.dataset.optIndex = String(i);
          btn.dataset.optValue = value;
          btn.setAttribute('role', 'radio');
          list.appendChild(btn);
        });

        group.appendChild(label);
        group.appendChild(list);
        wrap.appendChild(group);
      });
    }

    selectOption(button) {
      var i = parseInt(button.dataset.optIndex, 10);
      this.selected[i] = button.dataset.optValue;
      this.pcMsg.textContent = '';
      this.pcMsg.classList.remove('is-error');
      this.updateVariant();
    }

    updateVariant() {
      var self = this;
      var product = this.product;
      if (!product) return;

      var variant = product.variants.filter(function (v) {
        return v.options.every(function (option, i) { return option === self.selected[i]; });
      })[0] || null;
      this.variant = variant;

      /* Option buttons */
      this.pcOptions.querySelectorAll('[data-opt-index]').forEach(function (btn) {
        var i = parseInt(btn.dataset.optIndex, 10);
        var value = btn.dataset.optValue;
        var isSelected = self.selected[i] === value;
        btn.classList.toggle('is-selected', isSelected);
        btn.setAttribute('aria-checked', isSelected ? 'true' : 'false');

        var possible = product.variants.some(function (v) {
          return v.available && v.options[i] === value && v.options.every(function (option, j) {
            return j === i || option === self.selected[j];
          });
        });
        btn.classList.toggle('is-unavailable', !possible);
      });

      this.pcOptions.querySelectorAll('[data-opt-name]').forEach(function (label, i) {
        label.textContent = label.dataset.optName + ': ' + (self.selected[i] || '');
      });

      /* Image */
      var image = (variant && variant.image) || product.image;
      if (image) {
        this.pcImg.src = image;
        this.pcImg.style.visibility = 'visible';
      } else {
        this.pcImg.removeAttribute('src');
        this.pcImg.style.visibility = 'hidden';
      }

      /* Price */
      var priceSource = variant || product.variants[0];
      this.pcPrice.textContent = priceSource ? priceSource.price : '';
      if (this.opts.showCompare && priceSource && priceSource.compare) {
        this.pcWas.textContent = priceSource.compare;
        this.pcWas.hidden = false;
      } else {
        this.pcWas.textContent = '';
        this.pcWas.hidden = true;
      }

      /* Button */
      if (!variant) this.setAtcState('unavailable');
      else if (!variant.available) this.setAtcState('soldout');
      else this.setAtcState('ready');
    }

    setAtcState(state) {
      var btn = this.pcAtc;
      var t = this.opts.text;
      btn.classList.remove('is-loading', 'is-added');
      btn.disabled = false;

      switch (state) {
        case 'adding':
          btn.textContent = t.adding;
          btn.classList.add('is-loading');
          btn.disabled = true;
          break;
        case 'added':
          btn.textContent = t.added;
          btn.classList.add('is-added');
          break;
        case 'soldout':
          btn.textContent = t.soldout;
          btn.disabled = true;
          break;
        case 'unavailable':
          btn.textContent = t.unavailable;
          btn.disabled = true;
          break;
        default:
          btn.textContent = t.add;
      }
    }

    addToCart() {
      var self = this;
      var variant = this.variant;
      if (!variant || !variant.available || this._adding) return;

      this._adding = true;
      this.setAtcState('adding');
      this.pcMsg.textContent = '';
      this.pcMsg.classList.remove('is-error');

      var drawer = document.querySelector('cart-drawer');
      var useDrawer = this.opts.afterAdd === 'drawer' && drawer && typeof drawer.renderContents === 'function';
      var sections = ['cart-icon-bubble'];
      if (useDrawer) sections.push('cart-drawer');

      fetch(this.opts.cartAddUrl + '.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          id: variant.id,
          quantity: 1,
          sections: sections.join(','),
          sections_url: window.location.pathname
        })
      })
        .then(function (response) {
          return response.json().then(function (data) {
            if (!response.ok || data.status) {
              throw new Error(data.description || data.message || self.opts.text.error);
            }
            return data;
          });
        })
        .then(function (data) {
          self.updateCartBubble(data.sections);

          /* Let other theme parts know the cart changed (read-only use of theme events) */
          try {
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'vt-watch-and-buy', productVariantId: variant.id, cartData: data });
            }
          } catch (e) {}
          document.dispatchEvent(new CustomEvent('vt-wab:added', { detail: { variantId: variant.id, item: data } }));

          if (self.opts.afterAdd === 'cart') {
            window.location.href = self.opts.cartUrl;
            return;
          }

          if (useDrawer) {
            self.close();
            try {
              drawer.classList.remove('is-empty');
              drawer.renderContents(data);
            } catch (e) {
              window.location.href = self.opts.cartUrl;
            }
            return;
          }

          self.setAtcState('added');
          window.clearTimeout(self._addedTimer);
          self._addedTimer = window.setTimeout(function () {
            if (self.variant === variant) self.updateVariant();
          }, 2200);
        })
        .catch(function (error) {
          self.pcMsg.textContent = (error && error.message) || self.opts.text.error;
          self.pcMsg.classList.add('is-error');
          self.updateVariant();
        })
        .then(function () {
          self._adding = false;
        });
    }

    updateCartBubble(sections) {
      if (!sections || !sections['cart-icon-bubble']) return;
      var bubble = document.getElementById('cart-icon-bubble');
      if (!bubble) return;
      var doc = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
      var inner = doc.querySelector('.shopify-section');
      bubble.innerHTML = inner ? inner.innerHTML : doc.body.innerHTML;
    }
  }

  window.customElements.define('vt-watch-and-buy', VTWatchAndBuy);
})();
